var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QuestionArea',{attrs:{"belong-to":true,"problem-status":4,"enable-create":false,"enable-updown":false,"enable-delete":false,"data-source":_vm.dataSource,"getColproblemManagement":_vm.getColproblemManagement,"moreLoading":_vm.moreLoading,"busy":_vm.busy,"totalCount":_vm.totalCount},on:{"eventcol":_vm.eventcol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }